module.exports = __webpack_public_path__ + "img/xixue.7a25cdb4.png";